import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.baromoney-transfer-setting.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const autoLcBaromoneyTransferSetting = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    title: "캐쉬 이동 설정",
    description: "캐쉬 이동 설정 목록 화면 입니다.",
    search_placeholder: "검색어를 입력해주세요.",
    keyword_search: "키워드 검색",
    search_button: "검색",
    created_name: "등록일자",
    status_tltle: "사용여부",
    source: "차감대상",
    target: "이동대상",
    search_type: "조회기준",
    store: "상점",
    list: {
        table: {
            sourcename: "차감대상",
            targetname: "이동대상",
            moveFix: "차감액(정액)",
            isDeleted: "사용유무",
            createdAt: "등록일자",
            applyDate: "적용시작일자",
            expireDate: "적용종료일자",
            moveMemo: "차감대상메모",
        },
    },
    keywordType: {
        memo_search: "차감대상 메모",
        created_id_search: "처리자ID",
        created_name_search: "처리자명",
    },
    status: {
        all: "전체",
        use: "사용",
        delete: "삭제",
        exclude_expired: "만료제외",
    },
    detail: {
        detail_view: "상세보기 (No. {id})",
        sourcename_info: "차감대상 정보",
        sourcename_type: "차감대상 구분",
        sourcename_code: "차감대상 코드",
        move_info: "차감조건 정보",
        movePeriodDay: "차감주기",
        moveFix: "차감액(정액)",
        moveRate: "차감율(정률 %)",
        moveTag: "라이더배달대행수수료는 이동대상허브 오더인 경우임",
        moveMemo: "차감메모",
        applyDate_expireDate: "차감기간",
        target_info: "이동대상 정보",
        target_type: "이동대상 구분",
        target_code: "이동대상 코드",
        use_info: "사용여부 정보",
        use: "사용여부",
        day: {
            one: "일",
            everyday: "매일",
            monthly: "매월",
            monthly_end: "매월 말일",
        },
        servicetype: {
            none: "무관",
            order: "주문",
            delivery: "배달",
            quick: "퀵",
            lease_remittance: "리스비송금",
        },
    },
};
